import { createI18n } from 'vue-i18n'
import { zacetniJezik } from './jezik'
import en from './locales/en'
import sl from './locales/sl'

export type { AvailableLocales } from './jezik'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    // Shranjen jezik (changeLocale) velja tudi po osvežitvi strani, ne samo do nje.
    locale:           zacetniJezik(localStorage.getItem('locale')),
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],
})

export default i18n
